// extracted by mini-css-extract-plugin
export default {"messageContainer":"WarningMessage-module__messageContainer--faqxE"};